// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file responses/v1/shipping_rate_definition_response.proto (package responses.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import { file_responses_v1_country_response } from './country_response_pb';
import type { ShippingRateDefinitionType } from '../../settings/v1/shipping_rate_definition_type_pb';
import { file_settings_v1_shipping_rate_definition_type } from '../../settings/v1/shipping_rate_definition_type_pb';
import type { ShippingRateTier } from '../../settings/v1/shipping_rate_tier_pb';
import { file_settings_v1_shipping_rate_tier } from '../../settings/v1/shipping_rate_tier_pb';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file responses/v1/shipping_rate_definition_response.proto.
 */
export const file_responses_v1_shipping_rate_definition_response: GenFile =
    /*@__PURE__*/
    fileDesc(
        'CjRyZXNwb25zZXMvdjEvc2hpcHBpbmdfcmF0ZV9kZWZpbml0aW9uX3Jlc3BvbnNlLnByb3RvEgxyZXNwb25zZXMudjEi1wEKHlNoaXBwaW5nUmF0ZURlZmluaXRpb25SZXNwb25zZRIKCgJpZBgBIAEoBBIMCgRuYW1lGAIgASgJEjUKBHR5cGUYAyABKA4yJy5zZXR0aW5ncy52MS5TaGlwcGluZ1JhdGVEZWZpbml0aW9uVHlwZRIQCghjdXJyZW5jeRgEIAEoCRIWCglmcmVlX2Zyb20YBSABKAFIAIgBARIsCgVyYXRlcxgGIAMoCzIdLnNldHRpbmdzLnYxLlNoaXBwaW5nUmF0ZVRpZXJCDAoKX2ZyZWVfZnJvbUKOAQoQY29tLnJlc3BvbnNlcy52MUIjU2hpcHBpbmdSYXRlRGVmaW5pdGlvblJlc3BvbnNlUHJvdG9QAVoELi9wYqICA1JYWKoCDFJlc3BvbnNlcy5WMcoCDFJlc3BvbnNlc1xWMeICGFJlc3BvbnNlc1xWMVxHUEJNZXRhZGF0YeoCDVJlc3BvbnNlczo6VjFiBnByb3RvMw',
        [
            file_responses_v1_country_response,
            file_settings_v1_shipping_rate_definition_type,
            file_settings_v1_shipping_rate_tier,
        ]
    );

/**
 * @generated from message responses.v1.ShippingRateDefinitionResponse
 */
export type ShippingRateDefinitionResponse = Message<'responses.v1.ShippingRateDefinitionResponse'> & {
    /**
     * @generated from field: uint64 id = 1;
     */
    id: bigint;

    /**
     * @generated from field: string name = 2;
     */
    name: string;

    /**
     * @generated from field: settings.v1.ShippingRateDefinitionType type = 3;
     */
    type: ShippingRateDefinitionType;

    /**
     * @generated from field: string currency = 4;
     */
    currency: string;

    /**
     * free_from is the cart subtotal the rate becomes free delivery from, in the
     * rate's currency. Optional because a rate with no free shipping threshold
     * has none, which is not the same as a threshold of zero — that one is free
     * from the first order.
     *
     * @generated from field: optional double free_from = 5;
     */
    freeFrom?: number | undefined;

    /**
     * rates are the tiers of the definition: the delivery cost and the transit
     * estimate per bound. A flat definition has a single unbounded tier, an
     * order amount or package weight one has a tier per band.
     *
     * @generated from field: repeated settings.v1.ShippingRateTier rates = 6;
     */
    rates: ShippingRateTier[];
};

/**
 * Describes the message responses.v1.ShippingRateDefinitionResponse.
 * Use `create(ShippingRateDefinitionResponseSchema)` to create a new message.
 */
export const ShippingRateDefinitionResponseSchema: GenMessage<ShippingRateDefinitionResponse> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_shipping_rate_definition_response, 0);
